import '../dist/survey-v1.css'
import '../blueprints/survey-v1.ts'
